import { FormSectionHandler } from '../entity.handler';
import { DeviceTypeResponse, IdName, DeviceTypeUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers, EMPTY_GUID } from '../utils';
import { AssetGroupingService } from 'app/services';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    parent?: IdName;
    shortName?: string;
    tag?: string;
}


export class DeviceTypeDetailsSectionHandler implements FormSectionHandler<DeviceTypeResponse, EditorValues> {

    type = 'form';
    icon = ICONS.device;
    bulk = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private grouping: AssetGroupingService,
        private creating: boolean
    ) {
    }

    private properties = ['name', 'parent', 'shortName', 'tag'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.DEVICETYPE.DETAILS.${key}`, values);
    }

    applyUpdate(entity: DeviceTypeResponse, payload: DeviceTypeUpdateRequest): Promise<DeviceTypeResponse> {
        this.grouping.clear(); // clear our grouping cache after an update
        return this.admin.applyUpdate(api => api.entities.updateDeviceType(entity.id, payload));
    }

    mapEntityToEditor(entity: DeviceTypeResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: DeviceTypeUpdateRequest, values: EditorValues): Promise<DeviceTypeUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    async getFields(entity: DeviceTypeResponse): Promise<FormBuilderField[]> {
        // const parentDeviceTypes = await this.admin.getCached(`listDeviceTypes/${this.ownerId}/0/1000//parent=null`, api => api.entities.listDeviceTypes(this.ownerId, false, 0, 1000, undefined, `parent=null`), 60);

        const parentDeviceTypes = await this.admin.getCached(`listDeviceTypes/${this.ownerId}/0/1000///`, api => api.entities.listDeviceTypes(this.ownerId, false, 0, 1000, undefined, undefined), 0);
        parentDeviceTypes.items = parentDeviceTypes.items.filter(x => x.parent === null);
        return [
            this.creating || entity.parent
                ? ComboField('parent', this.translate('FIELDS.PARENT'), true, [{ key: EMPTY_GUID, value: this.admin.i18n.instant('SHARED.ROOT') }, ...parentDeviceTypes.items.map(x => ({ key: x.id, value: x.name }))], IdNameComboValueHandlers)
                : null,
            TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            TextField('shortName', this.translate('FIELDS.SHORTNAME'), true, 1, 255),
            TextField('tag', this.translate('FIELDS.TAG'), true, 1, 255),
        ].filter(x => x);
    }

}
